import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Skeleton } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import MUISelect from "../../../Component/UI/MUISelect/MUISelect";
import { AuthContext } from "../../../context/auth-context";
import ProductItem from "../../CategoryDiscovery/Products/ProductItem";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import MUICard from "./../../../Component/UI/MUICard/MUICard";
import useCustomerReviews from "./../../CategoryDiscovery/CustomerReviews/useCustomerReviews";
import useClassifyProduct from "./../../CategoryDiscovery/Products/useClassifyProduct";
import CompetitorItem from "./CompetitorItem";
import classes from "./Competitors.module.css";
import { LLM_OPTIONS } from "../../../utils/constant";
import { filterKey } from "../BrandAudit";
import { tab } from "../BrandScore/BrandScore";
import Checkbox from "@mui/material/Checkbox";
import {OVERVIEW_LLM_LABELS} from "../../../utils/constant"

export default function Competitors(
  { category, brand, llm, market, isCategoryOverview } = false
) {
  const [error, setError] = useState();
  const containerRef = useRef(null);
  const { user } = useContext(AuthContext);
  const { license_status } = user?.customer;

  const abortControllersRef = useRef([]);
  const discoveryCtx = useContext(DiscoveryContext);
  const { classifiedProducts } = useClassifyProduct();
  const selectedMarket = discoveryCtx.state.selectedMarket;
  const selectedPersona = discoveryCtx.state.selectedPersona;
  const selectedLLM = discoveryCtx?.state?.selectedLLM;
  const { loading: reviewsLoading, reviews } = useCustomerReviews();

  let competitors = discoveryCtx.competitors[category].map((c) => c.name);

  let brandScoreTotal = discoveryCtx.brand_scores[llm][category]?.[1]?.total;
  useEffect(() => {
    if (brandScoreTotal > 0 || discoveryCtx.state.id) return;
    // getBrandIndexScores();

    return () => {
      //abortControllersRef.current.forEach((controller) => controller.abort());
    };
  }, [brandScoreTotal, competitors.length, discoveryCtx.state.id]);

  useEffect(() => {
    if (discoveryCtx.abort_launch) {
      abortControllersRef.current.forEach((controller) => controller.abort());
    }
  }, [discoveryCtx.abort_launch]);

  let brandData = discoveryCtx.brand_scores[llm][category][selectedMarket][selectedPersona];
  const scroll = (direction) => {
    if (containerRef.current) {
      const scrollAmount = 480;
      const newScrollPosition =
        direction === "next"
          ? containerRef.current.scrollLeft + scrollAmount
          : containerRef.current.scrollLeft - scrollAmount;
      containerRef.current.scrollTo({
        left: newScrollPosition,
        behavior: "smooth",
      });
    }
  };

  let id = `competitor`;

  let uniqueKey = `${tab[category]}_${id}_${selectedLLM ?? ""}_${selectedMarket ?? ""}_${selectedPersona ?? ""}`;

  const { checked } = useIsSelectedSection({ id, uniqueKey });

  return (
    <MUICard>
      <div className="Heading-checkbox">
        <h5>
          {discoveryCtx.type === "category"
            ? "Products"
            : "Competitor Analysis"}
        </h5>

        {discoveryCtx.state.showReportCheckbox && isCategoryOverview && (
          <Checkbox
            checked={checked}
            onChange={() => {
              discoveryCtx?.clickComponentCheckbox({
                uniqueKey,
                filter: {
                  id: id,
                  title:
                    discoveryCtx.type === "category"
                      ? "Products"
                      : "Competitor Analysis",
                  tab: tab[category],
                  uniqueKey,
                  category: category,
                  market: selectedMarket,
                  llm
                },
                checked,
                id,
              });
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        )}

        <div
          style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}
          className={classes.dropdownWrapper}
          id="llm_options"
        >
          <MUISelect
            fullWidth={false}
            optionValue={selectedLLM}
            label={"LLM"}
            id={filterKey.llm}
            options={(discoveryCtx.llm || []).map((llm) => {
              const match= OVERVIEW_LLM_LABELS[llm]
              return {
                name: match ? match : llm,
                value: llm,
              };
            })}
            onChange={(e) => {
              discoveryCtx.updateSelectedLLM(e.target.value);
            }}
          />
        </div>
      </div>

      {discoveryCtx.type === "category" && (
        <>
          <MUIIconButton
            className={`${classes.chevron_btn} ${classes.prev}`}
            onClick={() => scroll("prev")}
          >
            <ArrowBackIosNewIcon />
          </MUIIconButton>
          <MUIIconButton
            className={`${classes.chevron_btn} ${classes.next}`}
            onClick={() => scroll("next")}
          >
            <ArrowForwardIosIcon />
          </MUIIconButton>
        </>
      )}
      <div
        ref={containerRef}
        id={id}
        style={{ position: "relative" }}
        className={
          discoveryCtx.type === "category"
            ? classes.products_container
            : classes.container
        }
      >
        {competitors?.map((competitor, index) => {
            return (
              <React.Fragment key={index}>
                {discoveryCtx.type === "category" ? (
                  <ProductItem
                    classifiedProducts={classifiedProducts}
                    index={index}
                    name={competitor}
                    brandIndex={
                      brandData[
                        index + (discoveryCtx.type === "category" ? 0 : 1)
                      ]
                    }
                    reviews={reviews[index]}
                    reviewLoading={reviewsLoading}
                  />
                ) : (
                  <React.Fragment key={index}>
                    {/* {brandData[index + 1] ? ( */}
                      <div id={`competitoritem-${index + 1}`}>
                        <CompetitorItem
                          competitor={competitor}
                          brandIndex={brandData[index + 1]}
                          brand={brand}
                          llm={llm}
                          category={category}
                          market={selectedMarket}
                          persona = {selectedPersona}
                        />
                      </div>
                    {/* ) : (
                      <Skeleton
                        variant="rounded"
                        style={{
                          flexGrow: 1,
                          height: 220,
                          flexBasis: "calc(50% - 12.5px)",
                        }}
                      />
                    )} */}
                    {index < competitors.length - 1 && (
                      <div className={classes.separator}></div>
                    )}
                  </React.Fragment>
                )}
              </React.Fragment>
            );
          })}
      </div>
    </MUICard>
  );
}
